import React, { useState, useEffect } from 'react';

const Notification = () => {
  const [visible, setVisible] = useState(false);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleShowNotification = (event) => {
      setTitle(event.detail.title);
      setMessage(event.detail.message);
      setVisible(true);

      setTimeout(() => {
        setVisible(false);
      }, 4000);
    };

    window.addEventListener('showNotification', handleShowNotification);

    // Welcome notification
    setTimeout(() => {
      const welcomeEvent = new CustomEvent('showNotification', {
        detail: {
          title: 'Bienvenido a Myntar',
          message: 'Descubre cómo la IA conversacional transforma tu negocio.'
        }
      });
      window.dispatchEvent(welcomeEvent);
    }, 2000);

    return () => {
      window.removeEventListener('showNotification', handleShowNotification);
    };
  }, []);

  return (
    <div className={`notification ${visible ? 'show' : ''}`}>
      <div className="notification-header">
        <span className="notification-icon">✨</span>
        <span className="notification-title">{title}</span>
      </div>
      <div className="notification-message">{message}</div>
    </div>
  );
};

export default Notification;
